import posthog from "posthog-js";
import userContext from "@modern/services/user_context";
import retailerContext from "@modern/services/retailer_context";

export default function initPosthog() {
  const posthogClientKey = window["C"]?.POSTHOG_CLIENT_KEY;
  if (!posthogClientKey) {
    console.warn("Posthog client key not configured. Posthog will not be initialized.");
    return;
  }
  posthog.init(posthogClientKey, {
    api_host: "https://us.i.posthog.com",
    person_profiles: "identified_only", // or 'always' to create profiles for anonymous users as well
  });

  const user = userContext.context.user;
  const currentRetailer = retailerContext.get();

  if (user) {
    const posthogUser = {
      email: user.email,
      name: user.first_name + " " + user.last_name,
      retailerID: currentRetailer?.id,
      retailerState: currentRetailer?.state,
      retailerName: currentRetailer?.name,
      role: user.role,
    };
    posthog.identify(user.id.toString(), posthogUser);
  }
}
